export const accessToken = "accessToken";
export const refreshToken = "refreshToken";

export const roleClaim = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
